<template>
  <div class="content">
    <el-tabs
      class="tabLv3"
      type="border-card"
      v-model="tabName"
    ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="config">
        <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> Mybatis配置</span>
        <normalNav :parent="self">
          <button
            class="GreenSmBtn"
            @click="add"
          >新增</button>
        </normalNav>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_config"
            ref="searchForm_config"
          >
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="MyBatis/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_config"
          >
            <template slot="last">
              <el-table-column
                label="操作"
                width="300"
                align="center"
              >
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.row)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :title="title"
          :visible.sync="editDialogVisible"
        >
          <el-form
            :model="addForm"
            :rules="addRule"
            ref="addForm"
          >
            <el-form-item
              label="数据库地址:"
              prop="url"
            >
              <el-input v-model.trim="addForm.url"></el-input>
            </el-form-item>
            <el-form-item
              label="用户名"
              prop="username"
            >
              <el-input v-model="addForm.username"></el-input>
            </el-form-item>
            <el-form-item
              label="密码:"
              prop="password"
            >
              <el-input v-model.trim="addForm.password"></el-input>
            </el-form-item>
            <el-form-item
              label="驱动类名:"
              prop="driveClassName"
            >
              <el-input v-model.trim="addForm.driveClassName"></el-input>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              class="cancelButton"
              @click="editDialogVisible = false"
            >取消</el-button>
            <el-button
              class="confirmButton"
              type="primary"
              @click="sureAdd"
            >确定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";

export default {
  data() {
    return {
      status: "",
      tabName: "config",
      form_config: {},
      title: "新增巡检点",
      addForm: {},
      editDialogVisible: false,
      data: {},
      other: {},
      config: [
        {
          label: "数据库地址",
          prop: "url",
        },
        {
          label: "用户名",
          prop: "username",
        },
        {
          label: "密码",
          prop: "password",
        },
        {
          label: "驱动类名",
          prop: "driveClassName",
        },
      ],
      items: [
        {
          type: "input",
          prop: "url",
          label: "数据库地址",
          placeholder: "",
        },
        {
          type: "input",
          prop: "username",
          label: "用户名",
          placeholder: "",
        },
        {
          type: "input",
          prop: "password",
          label: "密码",
          placeholder: "",
        },
        {
          type: "input",
          prop: "driveClassName",
          label: "驱动类名",
          placeholder: "",
        },
      ],
      areaTreeVisible: false,
      addAreaTreeVisible: false,
    };
  },
  computed: {
    self() {
      return this;
    },
    addRule() {
      let that = this;
      return {
        name: descriptor(new Map([[true, "请输入巡检点名称"]]), "blur"),
        regionName: descriptor(new Map([[true, "请选择巡检点区域"]]), "blur"),
        nfc: descriptor(new Map([[true, "请输入nfc"]]), "blur"),
      };
    },
  },
  methods: {
    reset_config(fn) {
      fn();
      this.form_config = {};
    },
    search_config(fn) {
      fn();
    },
    add() {
      this.status = "adding";
      this.title = "新增Mybatis配置";
      this.addForm = {};
      this.editDialogVisible = true;
      this.$refs.addForm.resetFields();
    },
    edit(data) {
      this.status = "editing";
      this.title = "编辑Mybatis配置";
      this.$set(this.addForm, "url", data.url);
      this.$set(this.addForm, "username", data.username);
      this.$set(this.addForm, "password", data.password);
      this.$set(this.addForm, "driveClassName", data.driveClassName);
      this.$set(this.addForm, "id", data.id);
      this.editDialogVisible = true;
    },
    deleteMsg(index, row) {
      this.$confirm("确定删除Mybatis配置?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning",
      }).then(() => {
        this.$axiosdelete("MyBatis/delete", {
          params: {
            id: row.id,
          },
        }).then((res) => {
          this.$refs.table_config.getData();
          this.$message.success("删除成功");
        });
      });
    },
    selRegionData(data) {
      this.$set(this.form_config, "regionName", data.name);
      this.$set(this.form_config, "area_id", data.id);
    },
    addSelRegionData(data) {
      this.$set(this.addForm, "regionName", data.name);
      this.$set(this.addForm, "area_id", data.id);
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.form_config = {};
          this.$axiospost(
            this.status == "adding" ? "MyBatis/add" : "MyBatis/update",
            this.addForm
          ).then((res) => {
            this.editDialogVisible = false;
            this.$refs.table_config.getData();
            this.$message.success("添加成功");
          });
        }
      });
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
  },
  mounted() {
    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });
    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/demo/index.vue